<template>
    <div>
        <e-dialog
                dialog-title="查看导入结果"
                :center-dialog-visible="importResultVisible"
                popup-width="800px"
                :closeBtn="true"
                :showCloseBtn="showCloseBtn"
                :showBtn="showBtn"
                @resetPopupData="handleClose">
            <tableList
                    rowKey="id"
                    :loading="false"
                    :index-show="true"
                    :indexShow="indexShow"
                    :table-data="tableData"
                    :table-label="tableLabel">
                <template v-slot:fileUrl="slot">
                    <el-button type="text" @click="downloadResult(slot.scope.row.fileUrl,slot.scope.row.fileName)">下载导入结果</el-button>
                </template>
            </tableList>
            <div class="margin-t20 danger">导入结果只保留最近10次的记录</div>
        </e-dialog>
    </div>
</template>

<script>
  import eDialog from '@/modules/projectA/components/common/e-dialog.vue';
  import tableList from '@/modules/projectA/components/common/e-table-list';
  import api from '../../../../../api/product';
  export default {
    name: "viewImportResultDialog",
    components:{
      eDialog,
      tableList
    },
    props:{
      importResultVisible:Boolean,
      importIdList:Array
    },
    data(){
      return{
        showCloseBtn:true,
        showBtn:false,
        indexShow:true,
        tableData: [],
        tableLabel: [
          {label: '导入时间', param: 'createTime', align: 'center',},
          {label: '操作人', param: 'memberName', align: 'center',},
          {label: '导入结果', param: '', align: 'center',slot:'fileUrl'},
        ],
      }
    },
    methods:{
      //下载
      downloadResult(fileUrl,fileName){
        console.log(fileUrl,fileName,'fileName')
        let a = document.createElement("a"); //创建一个<a></a>标签
        a.href = fileUrl; // 给a标签的href属性值加上地址，注意，这里是绝对路径，不用加 点.
        a.download = fileName; //设置下载文件文件名，这里加上.xls指定文件类型，pdf文件就指定.fpd即可
        a.style.display = "none"; // 障眼法藏起来a标签
        document.body.appendChild(a); // 将a标签追加到文档对象中
        a.click(); // 模拟点击了a标签，会触发a标签的href的读取，浏览器就会自动下载了
        a.remove(); // 一次性的，用完就删除a标签
      },
      handleClose(){
        this.$emit('closeDialog','importResultVisible');
        this.$emit('update:importResultVisible', false)
      },
      async centralizedSkuImportResult(){
        let res = await api.centralizedSkuImportResult({agreementId:this.$route.query.agreementId});
        if(res.success){
          this.tableData = res.data;
        }
      },
    },
    mounted() {
      this.centralizedSkuImportResult();
    }

  }
</script>

<style scoped lang="scss">

</style>